// extracted by mini-css-extract-plugin
module.exports = {"appTitle":"AppTitle_appTitle__Xg8j6"};